import React from 'react';
import CaretDown from '../../Assets/SVG/CaretDown';
import './ActionButton.css';
import { t } from 'i18next';

export default function ActionButton() {
  return (
    <div className="CaretDownButton">
      {t('common.actions')} <CaretDown />
    </div>
  );
}
